import { Page } from '../components/Page.js';

export function Placeholder({ title }: { title: string }) {
  return (
    <Page eyebrow="Section" title={title}>
      <div className="placeholder">
        <div>
          <div className="big">{title} is being built</div>
          <p className="muted" style={{ maxWidth: 420 }}>
            This section is part of the build and not yet wired up. The dashboard and the
            <strong> My conditions</strong> reference are available now.
          </p>
        </div>
      </div>
    </Page>
  );
}
